import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/lk/creative',
            name: 'creative',
            component: () => import('@/views/CreativePage.vue'),
        },
        {
            path: '/lk/writer',
            name: 'writer',
            component: () => import('@/views/Writer.vue'),
        },
        {
            path: '/ai/napisat-doklad',
            name: 'public-doklad',
            component: () => import('@/views/Writer.vue'),
        },
        {
            path: '/ai/napisat-referat',
            name: 'public-referat',
            component: () => import('@/views/Writer.vue'),
        },
        {
            path: '/:prefix(lk|ai|models)/:pathMatch(.*)*',
            name: 'chat',
            component: () => import('@/views/ChatApp.vue'),
            // props: true
        },
    ]
});

export default router
